import { Component, inject, input, output, resource } from '@angular/core';
import { PersonHelbredApi } from '@features/helbred/person-helbred/person-helbred.api';
import { DatePipe, DecimalPipe } from '@angular/common';
import { PrimeTemplate } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { BooleanPipe } from '@core/pipes/boolean.pipe';
import { PersonHelbred } from '../person-helbred/person-helbred.model';

@Component({
  selector: 'app-person-helbred-historik',
  imports: [
    DecimalPipe,
    PrimeTemplate,
    TableModule,
    TableRowDirective,
    DatePipe,
    BooleanPipe,
  ],
  templateUrl: './person-helbred-historik.component.html',
  styleUrl: './person-helbred-historik.component.css',
})
export class PersonHelbredHistorikComponent {
  personId = input<number>();
  refreshDate = input<Date>();
  personHelbredApi = inject(PersonHelbredApi);
  dateSelected = output<string>();

  data = resource({
    params: () => ({
      filter: JSON.stringify({ personId: this.personId() }),
      sortBy: 'gaeldendeFra',
      descending: true,
      refreshDate: this.refreshDate(),
    }),
    loader: async ({ params, abortSignal }) => {
      return await this.personHelbredApi.getList(params, abortSignal);
    },
  });

  onHelbredClicked(item: PersonHelbred) {
    if (item.gaeldendeFra) {
      this.dateSelected.emit(item.gaeldendeFra);
    }
  }
}
